import { render } from "./payQuestion.vue?vue&type=template&id=57c23be3&scoped=true"
import script from "./payQuestion.vue?vue&type=script&lang=js"
export * from "./payQuestion.vue?vue&type=script&lang=js"

import "./payQuestion.vue?vue&type=style&index=0&id=57c23be3&scoped=true&lang=scss"

import exportComponent from "D:\\sycode\\ijj-web\\iseso-mall-pc-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57c23be3"]])

export default __exports__